module.exports = __webpack_public_path__ + "assets/white_edit-a3500d.svg";